export const FORM_POPUP = `
formPopup {
  title
  ...on formPopup_Entry {
    formSettings {
      heading
      formId
      redirectLocation {
        url
      }
      onlyBusinessEmail
      withBorder
      errorValidateBusinessEmail
    }
  }
}
`